import React, { FC } from "react";
import cn from "classnames";
// import avatar from "src/assets/images/avatar.png";
import { Sizes } from "src/@types/sizes";
import { AVATAR_SIZE_VARIANTS } from "./constants";

interface Props {
  className?: string;
  containerClassName?: string;
  sizeVariant?: Sizes;
  avatarUrl?: string;
  altText?: string;
  title?: string;
}

export const Avatar: FC<Props> = ({
  className,
  sizeVariant = Sizes.XS,
  avatarUrl,
  altText,
  title
}) => {
  const combinedClassNames = cn(
    "rounded-full object-cover",
    AVATAR_SIZE_VARIANTS[sizeVariant],
    className
  );

  return (
    <img
      className={combinedClassNames}
      src={
        avatarUrl
        //  || avatar  -  add default image here
      }
      alt={altText}
      title={title || ""}
    />
  );
};
